import { useRef } from 'react'
import { useSelector } from 'react-redux'

import { selectEnableDynamicLoads } from '@/features/domain/territory'
import { useComponentSize } from '@/local/hooks'

import { StatsContainer } from '../StatsContainer'
import { RenderFrom } from '../../../../../components/RenderFrom'
import { TypeBlock } from './components/TypeBlock'
import { GoToPairedButton } from './components/GoToPairedButton'
import { TimeWindowsBlock } from './components/TimeWindowsBlock'
import { LoadsBlock } from './components/LoadsBlock'

interface Props {
  extOrder: uui.domain.client.rm.ExtendedOrderStep
}

const typeBlockWidth = 130
const loadsBlockWidth = 130
const timeWindowsBlockWidth = 200

const typeBlockRequiredWidth = typeBlockWidth
const timeWindowsBlockRequiredWidth = typeBlockRequiredWidth + timeWindowsBlockWidth

export function UnassignedOrderStats(props: Props) {
  const { extOrder } = props

  const ref = useRef<HTMLDivElement | null>(null)
  const [{ width }] = useComponentSize(ref)

  const enableDynamicLoads = useSelector(selectEnableDynamicLoads)

  if (!extOrder.isUnassigned) return null

  const {
    orderStepType,
    orderStep: { timeWindows, serviceTimeSec, trackingData },
    order: { loads },
  } = extOrder

  const loadsBlockRequiredWidth =
    timeWindowsBlockRequiredWidth + (Object.keys(loads).length / 3) * loadsBlockWidth

  return (
    <StatsContainer ref={ref}>
      <RenderFrom width={width} renderFrom={typeBlockRequiredWidth}>
        <TypeBlock type={orderStepType} serviceTimeSec={serviceTimeSec} />
        <GoToPairedButton extOrder={extOrder} />
      </RenderFrom>
      <RenderFrom width={width} renderFrom={timeWindowsBlockRequiredWidth}>
        <TimeWindowsBlock timeWindows={timeWindows} />
      </RenderFrom>
      <RenderFrom width={width} renderFrom={loadsBlockRequiredWidth}>
        <LoadsBlock
          loads={loads}
          trackingData={trackingData}
          showDynamicLoads={enableDynamicLoads}
        />
      </RenderFrom>
    </StatsContainer>
  )
}
